/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/privacy.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core

// App
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- PAGE
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/privacy', { ...({
  static: {
    refresh: '1h',
    urls: ['/privacy']
  }
}), ...{ filepath: "/app/client/pages/privacy.tsx", sourceLocation: { line: 17, column: 1 }, id: "privacy" } }, null, ({}) => {
  return <Page mainClassName="pt-28 pb-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-white to-pink-50">
            <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg border border-orange-100 p-8 md:p-10">
                <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-6">
                    Privacy Policy
                </h1>

                <p className="text-slate-600 text-sm mb-8">Last updated: October 15, 2025</p>

                <div className="prose prose-slate max-w-none">
                    <h2 className="text-xl font-bold text-slate-900 mb-2">1. Overview</h2>
                    <p className="text-slate-700 mb-6">
                        CrossPath ("we", "our", "us") provides software for recruiters. This Privacy Policy explains how
                        we collect, use, and protect personal information when you use our website and services,
                        including when you sign in with Google. If you do not agree with this policy, please do not use
                        our services.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">2. Information We Collect</h2>
                    <p className="text-slate-700 mb-3">We may collect the following categories of information:</p>
                    <ul className="list-disc pl-6 text-slate-700 mb-6">
                        <li>
                            <span className="font-semibold">Account Information</span>: name, email address, profile
                            image, company, role.
                        </li>
                        <li>
                            <span className="font-semibold">Authentication Data</span>: when you choose "Continue with
                            Google", we receive an identifier and verified email from Google to create or sign in to
                            your account.
                        </li>
                        <li>
                            <span className="font-semibold">Usage Data</span>: product interactions, device and browser
                            information, IP address, and diagnostics to improve performance and security.
                        </li>
                        <li>
                            <span className="font-semibold">Customer Content</span>: data you upload or generate in the
                            product (e.g., contacts, campaigns) in accordance with our Terms.
                        </li>
                    </ul>

                    <h3 className="text-lg font-bold text-slate-900 mb-2">Google User Data</h3>
                    <p className="text-slate-700 mb-3">
                        If you sign in with Google, we request the minimum scopes required for authentication (e.g.,
                        email and profile). We <span className="font-semibold">do not</span> access your Gmail content,
                        Google Drive files, or Calendar unless you explicitly grant such access for a specific feature.
                        Any access to Google APIs is limited to the purpose of providing and improving the features you
                        choose to use.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">3. How We Use Information</h2>
                    <ul className="list-disc pl-6 text-slate-700 mb-6">
                        <li>Provide, maintain, and improve the services</li>
                        <li>Authenticate and secure accounts, including fraud and abuse prevention</li>
                        <li>Personalize experiences and provide customer support</li>
                        <li>Analyze product performance and develop new features</li>
                        <li>Comply with legal obligations</li>
                    </ul>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">4. How We Share Information</h2>
                    <p className="text-slate-700 mb-3">
                        We do not sell personal data. We may share information with trusted service providers who
                        process data on our behalf to deliver the service (e.g., hosting, analytics, customer support),
                        under appropriate data protection agreements. We may disclose information if required by law, to
                        protect rights and safety, or with your explicit consent.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">5. Google Limited Use Requirements</h2>
                    <p className="text-slate-700 mb-3">
                        For any data obtained via Google APIs, we adhere to Google API Services User Data Policy,
                        including the Limited Use requirements. Data obtained via Google APIs is used only to provide or
                        improve user-facing features, is not transferred to third parties except as necessary to provide
                        those features, and is not used for advertising or sold.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">6. Data Retention</h2>
                    <p className="text-slate-700 mb-6">
                        We retain personal data only for as long as necessary to fulfill the purposes described in this
                        policy or as required by law. You may request deletion of your account data at any time.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">7. Your Rights</h2>
                    <p className="text-slate-700 mb-6">
                        Depending on your location, you may have rights to access, correct, export, or delete your
                        personal information, and to object to or restrict certain processing. To exercise these rights,
                        contact us using the details below.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">8. Security</h2>
                    <p className="text-slate-700 mb-6">
                        We implement administrative, technical, and organizational measures designed to protect personal
                        information. No system is perfectly secure; we continuously work to enhance our safeguards.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">9. International Data Transfers</h2>
                    <p className="text-slate-700 mb-6">
                        Your information may be processed in countries other than your own. Where applicable, we use
                        appropriate safeguards such as Standard Contractual Clauses for international transfers.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">10. Children’s Privacy</h2>
                    <p className="text-slate-700 mb-6">
                        Our services are not directed to children under 16, and we do not knowingly collect personal
                        information from them.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">11. Changes to This Policy</h2>
                    <p className="text-slate-700 mb-6">
                        We may update this Privacy Policy from time to time. We will post the updated version on this
                        page and update the "Last updated" date above. Material changes may be communicated through the
                        product or by email.
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mb-2">12. Contact Us</h2>
                    <p className="text-slate-700 mb-1">
                        If you have questions, concerns, or requests about this policy, contact:
                    </p>
                    <ul className="list-none pl-0 text-slate-700">
                        <li>
                            <span className="font-semibold">CrossPath</span>
                        </li>
                        <li>Email: hello@becrosspath.com</li>
                        <li>Website: https://becrosspath.com</li>
                    </ul>
                </div>
            </div>
        </Page>;
});
};
